export const AuthRoles = {
    Admin: 5,
    Analytics: 4,
    Editor: 3,
    Viewer: 1,
}